
import ShareIcon from '~/static/share.svg?inline';
import CopyIcon from '~/static/copy.svg?inline';
import {
  FACEBOOK_SHARE_URL,
  LINKEDIN_SHARE_URL,
  TWITTER_SHARE_URL,
} from '../../constants/global';

export default {
  components: {
    ShareIcon,
    CopyIcon,
  },

  props: {
    labelText: {
      type: String,
      required: false,
      default: '',
    },
    shareButtonText: {
      type: String,
      default: 'Share',
    },
    shareableText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    buttonClass: {
      type: String,
      required: false,
      default: '',
    },
    iconClass: {
      type: String,
      required: false,
      default: '',
    },
    wrapperClass: {
      type: String,
      required: false,
      default: '',
    },
    params: {
      type: Object,
      required: false,
      default: () => ({
        text: '',
        email: '',
        facebook: '',
        linkedIn: '',
        twitter: '',
      }),
    },
  },

  data() {
    return {
      showModal: false,
      modalClass: this.wrapperClass ? 'share-modal'.concat(' ', this.wrapperClass) : 'share-modal',
      socialMediaData: [
        {
          name: 'email',
          icon: ['fas', 'envelope'],
          iconColor: '#2F4B4C',
        },
        {
          name: 'facebook',
          icon: ['fab', 'facebook'],
          iconColor: '#4267B2',
        },
        {
          name: 'linkedIn',
          icon: ['fab', 'linkedin'],
          iconColor: '#0072B1',
        },
        {
          name: 'twitter',
          icon: ['fab', 'twitter'],
          iconColor: '#1DA1F2',
        },
      ],
    };
  },

  computed: {
    shareableTextWithParams() {
      return this.shareableText + (this.params.text || '');
    },
  },

  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.shareableTextWithParams);
        this.$toastr.s('Copied!');
      } catch (e) {
        // navigator doesn't exist, copy hidden elem
        // This is just for local envs, as navigator only works on https/localhost
        this.documentCopyToClipboard();
      }
    },

    documentCopyToClipboard() {
      const el = document.createElement('textarea');

      try {
        el.value = this.shareableTextWithParams;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);

        const selected = document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0) : false;

        el.select();
        document.execCommand('copy');

        this.$toastr.s('Copied!');
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
      } catch (e) {
        // failed to copy the created element
      } finally {
        document.body.removeChild(el);
      }
    },

    getSocialNetworkURL(socialNetwork) {
      // Additional social network parameters (i.e: utm parameters) to append
      // to the shareableText value.
      const {
        email = '',
        facebook = '',
        twitter = '',
        linkedIn = '',
      } = this.params;
      const params = {
        email: [
          `mailto:?body=${encodeURIComponent(this.shareableText + email)}`,
          `subject=${encodeURIComponent(this.title)}`,
        ],
        facebook: [
          `u=${this.shareableText}`,
          `quote=${encodeURIComponent(this.shareableText + facebook)}`,
        ],
        twitter: [
          'url= ',
          `text=${encodeURIComponent(this.shareableText + twitter)}`,
        ],
        linkedIn: [
          `url=${encodeURIComponent(this.shareableText + linkedIn)}`,
        ],
      };
      const urls = {
        email: `${params[socialNetwork].join('&')}`,
        facebook: `${FACEBOOK_SHARE_URL}${params[socialNetwork].join('&')}`,
        twitter: `${TWITTER_SHARE_URL}${params[socialNetwork].join('&')} `,
        linkedIn: `${LINKEDIN_SHARE_URL}${params[socialNetwork].join('&')} `,
      };

      return urls[socialNetwork] || '';
    },

    openSocialWindow(socialNetwork) {
      const width = 600;
      const height = 600;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      const windowName = socialNetwork !== 'email'
        ? `share-modal-${Math.round(Math.random() * 10000)}`
        : '_self';

      const windowFeatures = [
        `left=${left}`,
        `top=${top}`,
        `width=${width}`,
        `height=${height}`,
        `popup=${socialNetwork !== 'email'}`,
      ].join(',');
      window.open(this.getSocialNetworkURL(socialNetwork), windowName, windowFeatures);
    },
  },
};
